export default __webpack_public_path__ + "static/media/trampapo_01-01.77189969.jpg";